import { render, staticRenderFns } from "./myCreate.vue?vue&type=template&id=50541f6a&scoped=true"
import script from "./myCreate.vue?vue&type=script&lang=js"
export * from "./myCreate.vue?vue&type=script&lang=js"
import style0 from "./myCreate.vue?vue&type=style&index=0&id=50541f6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50541f6a",
  null
  
)

export default component.exports